export const MAX_POPOVER_EDIT_WIDTH = 400;
export const MIN_POPOVER_EDIT_WIDTH = 260;
export const TEXT_VALUE_MIN_TEXT_AREA_HEIGHT = 32;
export const TEXT_VALUE_MAX_TEXT_AREA_HEIGHT = 450;
export const FIELD_WIDTH_INLINE_THRESHOLD = 400;
